import queryString from 'query-string';

function sanitizeURL(url) {
    if (!url) {
        return url;
    }
    return url.replace(/\/\//, '/');
}

function accountServiceURL(contextPath = '') {
    return sanitizeURL(`${contextPath}/account`);
}

function accountSettingsServiceURL(contextPath = '', passwordUpdated = false) {
    if (passwordUpdated) {
        return sanitizeURL(`${contextPath}/login?passwordUpdated=true&url=/account/account-settings`);
    }
    return sanitizeURL(`${contextPath}/account/account-settings`);
}

function homepageServiceURL(contextPath = '') {
    return sanitizeURL(`${contextPath}/`);
}

function registryServiceURL(contextPath = '') {
    return sanitizeURL(`${contextPath}/registry/home`);
}

function wishlistServiceURL(contextPath, id) {
    if (id) {
        return sanitizeURL(`${contextPath}/wishlist/${id}`);
    }
    return sanitizeURL(`${contextPath}/wishlist`);
}

function ordersServiceURL(contextPath, dateRangeValue) {
    const params = {
        dateRangeValue: dateRangeValue
    };

    const queryParams = queryString.stringify(params);

    return sanitizeURL(`${contextPath}/orders?${queryParams}`);
}

function orderServiceURL(contextPath, orderId, customerZipCode) {
    const params = {};

    if (customerZipCode) {
        params.customerZipCode = customerZipCode;
    }

    const queryParams = queryString.stringify(params);

    return sanitizeURL(`${contextPath}/order/${orderId}?${queryParams}`);
}

export default {
    accountURL: accountServiceURL,
    accountSettingsURL: accountSettingsServiceURL,
    homepageURL: homepageServiceURL,
    wishlistURL: wishlistServiceURL,
    ordersURL: ordersServiceURL,
    orderURL: orderServiceURL,
    registryURL: registryServiceURL
};
